module.exports = __webpack_public_path__ + "static/media/printing-services-img2.783426c0.jpg";